import { render, staticRenderFns } from "./look-old.vue?vue&type=template&id=3d871eec&scoped=true"
import script from "./look-old.vue?vue&type=script&lang=js"
export * from "./look-old.vue?vue&type=script&lang=js"
import style0 from "./look-old.vue?vue&type=style&index=0&id=3d871eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d871eec",
  null
  
)

export default component.exports